import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Education extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Education </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      X-tended Reality (XR) took its beginning in the entertainment area, 
                      but over time it got the practical use too. And education did not stand aloof. 
                      The main goal of X-tended Reality in education is to make studying process exciting 
                      and more effective. XR simulations provide a deep understanding of the material by 
                      a learner with its further application in real life.                    
                      </h6>
                    <h6 className = "mt-4 line-height-h">
                      The strongest proof that X-tended Reality can make good for the education system is, 
                      in a way, the human brain. The fact is that the brain tends to remember 10% of what it reads, 
                      20% of what it hears, and 90% of what it does or simulates. So let’s see what XR technology 
                      can actually bring to the table in terms of education in 2018 and beyond.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Are we ready?</b>
                      <br></br>
                      Despite all advantages, X-tended Reality is yet far from widespread implementation into education. 
                      In spite the fact 97% of students would like to study some XR courses, only 23% of schools have 
                      tested the XR, and about 10% are planning to use it the next year or two. All the practical use of 
                      XR in education can be divided into two main groups: school/university studying and workplace learning. 
                      Practical applications of XR may be the following:
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>a. Virtual Fields Trips</b>
                      <br></br>
                      The most common and obvious use of XR is providing the ability of virtual visits to 
                      distant or physically inaccessible places.
                      <br></br>
                      <b>b. Special Education</b>
                      <br></br>
                      For people with the physical disabilities studying and exploring the world through a XR 
                      headset is a great option to get educated.
                      <br></br>
                      <b>c. Content Creation</b>
                      <br></br>
                      Currently, X-tended Reality courses are most often created for the science and history classes. 
                      Though in fact, the virtual format can be applied to any subject and theme.
                      <br></br>
                      <b>d. Medical Programs</b>
                      <br></br>
                      The big part of investments in XR education is directed towards training medical students and personnel. 
                      Different trainee programs are aimed to prepare doctors and nurses, and simulations help practice different 
                      clinical cases and improve skills.
                      <br></br>
                      <b>e. Training</b>
                      <br></br>
                      Most students say that studying complex material through practical tasks provides 
                      a better understanding of the subject. XR can provide a suitable and manageable 
                      environment for any kinds of training.
                      <br></br>
                      <b>f. Distant Learning</b>
                      <br></br>
                      With XR, online learning becomes more convenient and can even provide the sense of presence. 
                      Potentially, virtual classes have a chance to compete with traditional schools, but only as 
                      soon as XR becomes affordable.
                      <br></br>
                      <b>g. Design</b>
                      <br></br>
                      XR can aid design and modeling to progress to a qualitatively different level. 
                      This technology allows the creation of 3D models, displaying all details and features, 
                      editing, transformation, and testing in virtual environments.
                      <br></br>
                      <b>h. Recruiting</b>
                      <br></br>
                      Visiting a university via the virtual tour is a great chance to become familiar with the 
                      learning process and campus life while choosing the future “alma mater”.
                      <br></br>
                    </h6>
                      <h6 className = "mt-4 line-height-h">
                      <b>What makes XR good for education?</b>
                      <br></br>
                      X-tended Reality can be used in classrooms to enhance student learning and engagement. 
                      XR can transform the way educational content is delivered; it works on the premise of 
                      creating a virtual world — real or imagined — and allows users to interact with it. 
                      Being immersed in what you’re learning motivates you to fully understand it. 
                      It’ll require less cognitive load to process the information. Here are just a few 
                      properties that make XR so powerful for education.
                      <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>a. Visualization.</b> The most obvious benefit of using XR in education 
                      (for any other sphere it is also true) is the advanced way of visualization. 
                      X-tended Reality has become the universal tool to display objects, processes, 
                      locations, and historical events.
                      <br></br>
                      <b>b. Improvement of education quality.</b> As visualization helps to understand and remember,  
                      students can get even more immersive experiences with training simulations. 
                      XR is proven capable of fitting any school and university subject or program.
                      <br></br>
                      <b>c. Active participation.</b> These days, millennials may perceive conventional 
                      classroom studying a bit boring. Integrating XR into a curriculum is one way to 
                      enhance the learning process for them. Besides generating interest, XR can also 
                      remove distractions on a smartphone.
                      <br></br>
                      <b>d. No language barriers.</b> For international students, the language barrier often can be a problem. 
                      With X-tended Reality, studying materials in any foreign language can be implemented into XR software.
                      <br></br>
                      <b>e. Improving appraising system.</b> The research asserts that immediate rewarding positively impacts 
                      students’ further performance. Instead of traditional pointing out mistakes and failures, 
                      XR brings gamification aspects into the learning process, providing encourageable rewards systems.
                      <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Categories of XR educational experiences</b>
                      <br></br>
                      Where can we apply XR in education? The answer is almost everywhere. 
                      XR creates an infinite set of possibilities that people can experience.
                      Here are just a few types of experiences you can create with XR.
                      <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>a. Virtual fields trips. </b>

                      XR technology can be used to engage students in topics related to geography, 
                      history, or literature by offering a deeply immersive senses of place and time. 
                      Simply imagine geography lessons where you can visit any place on the globe — this 
                      type of experience is much more enriching than just reading about it.
                      <br></br>
                      <b>b. High tech training. </b>

                      XR is a good solution for highly technical training fields like the military or 
                      the medical industry. For example, the most significant challenge for medical students 
                      learning anatomy is understanding the body in three dimensions and how different systems 
                      fit together. XR can help overcome this problem.
                      <br></br>
                      <b>c. Internships. </b>

                      Getting exposure to different careers is an essential part of the learning process. 
                      From early childhood, we dream about what we want to be when we grow up, and those 
                      dreams are usually inspired by the professionals in our lives. Often, we get this 
                      understanding through internships.
                      <br></br>
                      <b>d. Group learning. </b>

                      Some of the most important knowledge we gain doesn’t come from what we hear from lecturers, 
                      but rather from from collegiality and debate. XR gives the opportunity to make learning 
                      experiences social by allowing students to communicate with each other. Using avatars and 
                      mapped facial expressions, people can come together to discuss, synthesize, and learn from one another.
                      <br></br>
                      <b>e. Distance learning. </b>

                      XR allows us to bridge the gap between educators and learners. With XR, distance learning 
                      tools can put educators and students together in the same room with digital representations 
                      of themselves — teachers can teleport into the XR world and guide students through their experiences.

                      <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Education templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Education;



// WEBPACK FOOTER //
// ./src/views/Pages/Education/Education.js